import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-shouqi",
  "use": "icon-shouqi-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-shouqi\"><path fill=\"#515151\" d=\"M896 864c-9.6 0-16-3.2-22.4-9.6L512 492.8 150.4 854.4c-12.8 12.8-32 12.8-44.8 0s-12.8-32 0-44.8l384-384c12.8-12.8 32-12.8 44.8 0l384 384c12.8 12.8 12.8 32 0 44.8-6.4 6.4-12.8 9.6-22.4 9.6z\" /><path fill=\"#515151\" d=\"M896 608c-9.6 0-16-3.2-22.4-9.6L512 236.8 150.4 598.4c-12.8 12.8-32 12.8-44.8 0s-12.8-32 0-44.8l384-384c12.8-12.8 32-12.8 44.8 0l384 384c12.8 12.8 12.8 32 0 44.8-6.4 6.4-12.8 9.6-22.4 9.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol